// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bot-exit-btn-NCbkXZ .semi-button.semi-button-with-icon-only{width:32px;padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bot-exit-btn": `bot-exit-btn-NCbkXZ`,
	"botExitBtn": `bot-exit-btn-NCbkXZ`
};
export default ___CSS_LOADER_EXPORT___;
